export default __webpack_public_path__ + "static/media/avatar-3.c9d9b0ca.jpg";